import React from 'react';
import { ProductSummary } from 'src/components/Basket/utils/basket-customisations';

import { sumTotal } from './helpers/SumTotal';
import classes from './ProductBlock.scss';

type Props = {
    product: ProductSummary;
    variant?: 'large' | 'normal' | 'small';
    noQuantity?: boolean;
    type?: string;
};

export const ProductBlock: React.FC<Props> = ({ product, variant, noQuantity, type }) => {
    const { image, items, name, sku } = product;
    const quantity = sumTotal(items);
    return (
        <div className={classes.productBlock} data-variant={variant}>
            <figure className={classes.productBlockImage}>
                <img src={image} alt={name} />
            </figure>
            <div className={classes.productBlockDetail}>
                <p className={classes.productBlockTitle}>{name}</p>
                <div className={classes.productBlockInfo}>
                    <p className={classes.productBlockSku}>{sku}</p>
                    <ul className={classes.productBlockList}>
                        {items.map((item) => {
                            return (
                                <li className={classes.productBlockItem} key={item.labels.join(',')}>
                                    {item.labels.join(', ')}
                                    {type && type === 'BundleCartItem' && `x${item.qty}`}
                                </li>
                            );
                        })}
                    </ul>
                    {!noQuantity && <p className={classes.productBlockQty}>Qty: {quantity}</p>}
                </div>
            </div>
        </div>
    );
};
